import { all } from './util';

// include this, then mark images with class "fs"


const canShowFullscreen = true;

// click event that triggers the fullscreen image display for the given HTMLImageElement
const showFsImage = (img: HTMLImageElement) => {
    if (canShowFullscreen) {
        const url =
            img.srcset
                ? img.srcset.split(',').map(s => s.replace(" 1x", "").replace(" 2x", "").replace(" 3x", "").replace(" 4x", "")).pop() || img.src
                : img.src

        const fsImageContainers = all<HTMLImageElement>('.fs-img');

        if (fsImageContainers.length) {
            const newImg = document.createElement('img');
            newImg.src = url;
            newImg.className = "fs-img__image";

            const fsImageContainer = fsImageContainers[0];
            fsImageContainer.appendChild(newImg);
            fsImageContainer.classList.add('fs-img__active');
        }
    }
}

// prepares the fullscreen image container

all<HTMLImageElement>('.fs-img').forEach(i => {
    i.addEventListener('click', () => {
        while (i.lastElementChild) {
            i.removeChild(i.lastElementChild);  // deletes all content
        }
        i.classList.remove('fs-img__active');   // then makes it disappear
    })
});


// prepares the fullscreen-enabled images
all<HTMLImageElement>('.fs').forEach(i => {
    i.addEventListener('click', e => {
        if (e.target instanceof HTMLImageElement) {
            showFsImage(e.target);
        }
    })
});

export {
    showFsImage
}